import { LeadSequenceStatus } from '@crm/api'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Flex, Select, SelectProps } from 'antd'

export const CampaignFilter = () => {
  const { t } = useLocales()

  const { params, updateQuery } = useQueryUpdate()

  const options: SelectProps['options'] = Object.values(LeadSequenceStatus).map(
    (value) => ({
      label: t(`campaigns.stats_${value}`),
      value: value
    })
  )

  return (
    <Flex gap={8} wrap="wrap" align="center">
      <Select
        value={params.status}
        allowClear
        placeholder={t('campaigns.status')}
        className="select-min-width"
        options={options}
        onChange={(status) => updateQuery({ status })}
      />
    </Flex>
  )
}
